// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackForm-cls1_mBZ","cls2":"FeedbackForm-cls2_N3c FeedbackForm-cls1_mBZ"};